module.exports = "/images/up.png?3ac01cb1c58f33b3e3e3912343a6243b";